import React, { Component } from 'react'
import { observer } from 'mobx-react'
import DataExplorerStore from './DataExplorerStore'
import DataExplorerHeader from './DataExplorerHeader'
import Panel from '../../UniformComponents/Panel'
import DataSelector from './DataSelector'
import DataPanel from './DataPanel'

import './dataExplorer.scss'

@observer
class DataExplorer extends Component {
    constructor(props) {
        super(props)
        this.DataExplorerStore = new DataExplorerStore(props.store)
    }

    render() {
        return (
            <div className="dataExplorer">
                <DataExplorerHeader DataExplorerStore={this.DataExplorerStore} />
                <Panel cssClass="dataExplorerPanel">
                    <div className="dataExplorerBody">
                        <DataSelector DataExplorerStore={this.DataExplorerStore} />
                        <DataPanel DataExplorerStore={this.DataExplorerStore} />
                    </div>
                </Panel>
            </div>
        )
    }
}

export default DataExplorer
